/**
 * Activity Matching Utilities
 *
 * Utilities for matching scanned barcodes against activity type names
 * to enable barcode-based activity selection.
 */

/**
 * Find activity types that match a scanned barcode value
 *
 * Performs case-insensitive exact match against activity type names.
 *
 * @param {string} scannedValue - The scanned barcode text
 * @param {Array} activityTypes - Available activity types with name and activityTypeRef
 * @returns {Array} Matching activity types
 *
 * @example
 * findMatchingActivities("Production", [
 *   { name: "Production", activityTypeRef: 1 },
 *   { name: "Setup", activityTypeRef: 2 }
 * ])
 * // Returns: [{ name: "Production", activityTypeRef: 1 }]
 */
export const findMatchingActivities = (scannedValue, activityTypes) => {
  if (!scannedValue || !activityTypes || !Array.isArray(activityTypes)) {
    return [];
  }

  const normalizedScan = scannedValue.trim().toLowerCase();

  return activityTypes.filter((at) => {
    return at.name && at.name.toLowerCase() === normalizedScan;
  });
};

/**
 * Check if an activity is disabled (already open)
 *
 * @param {number} activityTypeRef - The activity type ref to check
 * @param {number} openActivityTypeRef - The currently open activity type ref
 * @returns {boolean} True if the activity is disabled
 */
export const isActivityDisabled = (activityTypeRef, openActivityTypeRef) => {
  return activityTypeRef === openActivityTypeRef;
};
